<template>
  <div>
    <InformationreleaseTop></InformationreleaseTop>
  </div>
</template>

<script>
import InformationreleaseTop from './components/InformationreleaseTop.vue'
export default {
  components: {
    InformationreleaseTop
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style>
</style>